module.exports = __webpack_public_path__ + "assets/img/advantage_icon.94d83004.png";